import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLoading } from "../../context/SideContext";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import Alerts from "../../components/Alert";
import DashStudentNew from "../../components/DashStudent";
import DepDash from "../../components/DepDash";

const Dash = () => {
  const [singleUser, setSingleUser] = useState(null);
  const { token, setIsuserloggedin, role } = useAuth();
  const { loading, setLoading } = useLoading();

  async function getUsers() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/auth/getUser`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSingleUser(response.data.data);
    } catch (e) {
      console.error("Error fetching user details:", e);
      setIsuserloggedin(false);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (role === "student" || role === "department" || !role) {
      getUsers();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  if (role === "admin") {
    return <Navigate to='/admin' replace />;
  }

  if (loading || !singleUser) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <Spinner animation='border' role='status' variant='primary' />
      </div>
    );
  }

  if (role === "department") {
    return (
      <>
        <Alerts variant='success' />
        <DepDash singleUser={singleUser || {}} setSingleUser={setSingleUser} />
      </>
    );
  }

  return (
    <>
      <Alerts variant='success' />
      <DashStudentNew
        singleUser={singleUser}
        setSingleUser={setSingleUser}
        getUsers={getUsers}
      />
    </>
  );
};

export default Dash;


